import React from 'react';
import PropTypes from 'prop-types';

const FetchError = ({ refresh }) => (
    <div className="pp-fetchError">
        <p className="pp-fetchError__text">
            There&apos;s a technical issue that means we are currently unable to retrieve this
            data.
        </p>
        <p className="pp-fetchError__text">
            We are working to resolve this and expect service to return to normal shortly.
        </p>
        <p className="pp-fetchError__text">
            Your page should refresh in 20 seconds. If it does not refresh please click&nbsp;
            <button className="ui-link" onClick={refresh}>here</button>.
        </p>
        <p className="pp-fetchError__text">
            Apologies for any inconvenience this has caused.
        </p>
    </div>
);

FetchError.propTypes = {
    refresh: PropTypes.func.isRequired,
};

export default FetchError;



// WEBPACK FOOTER //
// ./src/js/shared/FetchError.jsx